import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionSendTransactionEditorComponent from './ActionSendTransactionEditorComponent';

class ActionSendTransactionEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionSendTransactionEditorComponent />} type='send-transaction' icon='add_notes' />;
  }
}

export default ActionSendTransactionEditorContainer;
